import React from 'react';
import ReactMarkdown from 'react-markdown';
import { graphql, Link } from 'gatsby';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import { Layout } from '@components';
import styled from 'styled-components';
import { Main, theme } from '@styles';
const { colors } = theme;

const StyledProjectContainer = styled(Main)`
  max-width: 1000px;
  .markdown-html {
    margin-bottom: 100px;
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 2em 0 1em;
    }

    code {
      font-size: 12px;
    }

    pre {
      background-color: #112340;
      overflow: auto;
      padding: 1.25em;
      font-family: 'SF Mono,Fira Code,Fira Mono,Roboto Mono,Lucida Console,Monaco,monospace';
    }
    blockquote {
      border-left-color: #ff0000;
      background-color: ${colors.lightNavy};
      p {
        margin: 1em 0;
        padding-top: 5px;
        line-height: 1.5;
        font-size: 16px;
        color: ${colors.lightSlate};
      }
    }
  }
`;

const StyledPostHeader = styled.header`
  margin-bottom: 50px;
  .skill {
    margin-right: 10px;
    font-size: 14px;
  }
`;
// const References = styled.div`
//   padding-top: 10px;
//   a {
//     text-decoration: underline;
//   }
// `;

const StyledPostDes = styled.div`
  margin-bottom: 70px;
`;

const ProjectTemplate = ({ data, location }) => {
  const { name, Description, Content, skills, PublishData, LiveURL } = data.strapiProject;

  return (
    <Layout location={location}>
      <Helmet>
        <title>{name} | Jane Li</title>
        <link rel="canonical" href="https://trust-janeli.netlify.app/projects" />
      </Helmet>

      <StyledProjectContainer>
        <span className="breadcrumb">
          <span className="arrow">&larr;</span>
          <Link to="/archive">All Projects</Link>
        </span>
        <StyledPostHeader>
          <a
            href={LiveURL}
            target="_blank"
            rel="nofollow noopener noreferrer"
            aria-label="External Link">
            <h1 className="medium-title">{name}</h1>
          </a>
          <p className="subtitle">
            <time>
              {new Date(PublishData).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
              })}
            </time>
            &nbsp;&nbsp;Completed - &nbsp;
            {skills &&
              skills.length > 0 &&
              skills.map((skill, i) => (
                <span key={i} className="skill">
                  #{skill.Name}
                </span>
              ))}
          </p>
        </StyledPostHeader>
        <StyledPostDes>
          <h2>Achievements:</h2> {Description}
          {/* <References>
            <b>References:</b> <Link to="/blog/9">Build a GraphQL API with Node/NestJS</Link>
          </References> */}
        </StyledPostDes>
        <ReactMarkdown source={Content} className="markdown-html" />
      </StyledProjectContainer>
    </Layout>
  );
};

export default ProjectTemplate;

ProjectTemplate.propTypes = {
  data: PropTypes.object,
  location: PropTypes.object,
};

export const pageQuery = graphql`
  query($slug: String!) {
    strapiProject(slug: { eq: $slug }) {
      id
      name
      Description
      Content
      LiveURL
      skills {
        Name
      }
      PublishData
      strapiId
    }
  }
`;
